export class GetSubscriptionStateError extends Error {
    public readonly name: string;
    public readonly stack: string;

    constructor(message: string, stack: string = '') {
        super(message);
        this.name = 'GetSubscriptionStateError';
        this.stack = stack;
        Object.setPrototypeOf(this, GetSubscriptionStateError.prototype);
    }
}
